<div class="mb-2 inline-block">
  <p-tabs [(value)]="activeTabIndex" (onChange)="onTabChange($event)">
    <p-tablist>
      <p-tab [value]="0">GHG</p-tab>
      <p-tab [value]="1">ISO 14064-1</p-tab>
    </p-tablist>
  </p-tabs>
</div>

<div class="table-container">
  @if (displayData.length > 0) {
    <!-- Tabla única con agrupaciones -->
    <div>
      <p-table
        [value]="tableData"
        [scrollable]="true"
        scrollHeight="600px"
        class="p-datatable-sm"
        [tableStyle]="{'min-width': '50rem'}">
        <ng-template #header>
          <tr>
            @for (col of columns; track col.field) {
              <th [class.text-right]="col.field !== 'Variation'">{{ col.header }}</th>
            }
          </tr>
        </ng-template>
        <ng-template #body let-row>
          <!-- Fila de header de grupo -->
          @if (isGroupHeader(row)) {
            <tr class="bg-gray-200 font-semibold">
              <td [attr.colspan]="columns.length" class="p-3">
                {{ row.groupKey }}
              </td>
            </tr>
          }
          <!-- Fila de totales -->
          @else if (isTotal(row)) {
            <tr class="font-bold bg-gray-100">
              <td>Total</td>
              <td class="text-right">{{ row.totals.Co2 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Ch4 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Ch4Bio | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.N2o | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Co2Bio | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Hfc | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Pfc | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Sf6 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Nf3 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.NoKyoto | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.TotalCo2e | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.ScopeCategoryPct | percent:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.InventoryPct | percent:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Uncertainty | percent:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.TotalT | number:'1.2-2' }}</td>
            </tr>
          }
          <!-- Fila de gran total GEI -->
          @else if (isGrandTotal(row)) {
            <tr class="font-bold bg-blue-100">
              <td>Total GEI</td>
              <td class="text-right">{{ row.totals.Co2 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Ch4 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Ch4Bio | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.N2o | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Co2Bio | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Hfc | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Pfc | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Sf6 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Nf3 | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.NoKyoto | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.TotalCo2e | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.ScopeCategoryPct | percent:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.InventoryPct | percent:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.Uncertainty | percent:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.TotalT | number:'1.2-2' }}</td>
            </tr>
          }
          <!-- Fila de datos consolidados -->
          @else {
            <tr>
              @for (col of columns; track col.field) {
                <td [class.text-right]="col.field !== 'Variation'">
                  @if (col.field === 'Variation') {
                    {{ row[col.field] }}
                  } @else if (col.field === 'ScopeCategoryPct' || col.field === 'InventoryPct' || col.field === 'Uncertainty') {
                    {{ row[col.field] | percent:'1.2-2' }}
                  } @else {
                    {{ row[col.field] | number:'1.2-2' }}
                  }
                </td>
              }
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  } @else {
    <div class="text-center py-8 text-gray-500">
      No hay resultados para mostrar
    </div>
  }
</div>
